import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function auszeichnungen() {
	let mySwiper;

	function initOrDestroySwiper() {
		if (window.innerWidth < 1024 && !mySwiper) {
			mySwiper = new Swiper(".swiper-auszeichnungen", {
				loop: true,
				modules: [Navigation, Pagination],
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				breakpoints: {
					500: {
						slidesPerView: 1,
					},
					768: {
						slidesPerView: 2,
					},
					1024: {
						slidesPerView: 3,
					},
				},
			});
		} else if (window.innerWidth >= 1024 && mySwiper) {
			mySwiper.destroy(true, true);
			mySwiper = null;
		}
	}

	initOrDestroySwiper();

	window.addEventListener('resize', initOrDestroySwiper);
}

export {auszeichnungen};